<script setup>
import { trans } from '@elements/translation';

defineProps({
  isRented: {
    type: Boolean,
    required: true,
  },
});
</script>

<template>
  <span v-if="isRented" class="hit-label hit-label--proposal_rent">
    {{ trans('offer_card.labels.proposal_rent') }}
  </span>
</template>
